// extracted by mini-css-extract-plugin
export default {"controls":"Controls_controls__aVu4n","controls__icon":"Controls_controls__icon__L-IvA"};